/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Delete_SuccessInputs */

const en_admin_invite_codes_delete_success = /** @type {(inputs: Admin_Invite_Codes_Delete_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code deleted`)
};

/**
* | output |
* | --- |
* | "Invite code deleted" |
*
* @param {Admin_Invite_Codes_Delete_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_delete_success = /** @type {((inputs?: Admin_Invite_Codes_Delete_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Delete_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_delete_success(inputs)
});
export { admin_invite_codes_delete_success as "admin.invite_codes.delete_success" }